<template>
  <main class="wrapper-content">
    <template v-if="!isLoading">
      <LmFormHeader :title="$t('Service')" :name="form.name" />
      <a-tabs :default-active-key="isOnEditMode? '3' : '1'">
        <a-tab-pane key="1" :tab="$t('Edit')">
          <b-card class="border">
            <b-row>
              <LmTextInput
                ref="nameInput"
                class="col-12 col-md-6"
                :label="$t('name')"
                v-model="$v.form.name.$model"
                :v="v('form.name')"
              />

              <LmTreeSelect
                class="col-12 col-md-6"
                :label="$t('Provider')"
                :options="providerOptions"
                v-model="form.provider"
              />

              <LmTextArea
                class="col-12 col-md-6"
                :label="$t('Description')"
                :placeholder="$t('enter_description')"
                v-model="form.description"
              />

              <LmTextInput
                class="col-12 col-md-6"
                :label="$t('Reference')"
                v-model="form.reference"
              />

              <LmUploadFiles
                v-if="form.showWelcomeSignButton"
                class="col-12"
                label="Fondos para opciones de carteles personalizados de bienvenida."
                duplicateCheck
                v-model="form.backgroundSigns"
                :dropzoneOptions="{
                  acceptedFiles: acceptedImages,
                  headers: {
                    'Cache-Control': null,
                    'X-Requested-With': null
                  },
                  withCredentials: true,
                  thumbnailWidth: 150,
                  maxFilesize: 20,
                  timeout: 120000,
                  addRemoveLinks: true,
                  maxFiles: null,
                  clickable: true
                }"
              />
              <small v-if="form.showWelcomeSignButton" class="col-12 mb-2">
                Los fondos seleccionados se mostrarán en la sección de carteles personalizados de bienvenida.
                Se recomienda seleccionar fondos de tamaño 1920x1080 píxeles para mejor visualización.
              </small>

              <div class="col-12">
                <hr  >
              </div>

              <LmCheckbox
                class="col-12 col-md-12"
                v-model="form.showNationalParksButton"
                :labelSingle="$t('Mostrar Botón, Planilla Parques Nacionales')"
                :variant="'switch'"
              />

              <LmCheckbox
                class="col-12 col-md-12"
                v-model="form.showOrderServiceButton"
                :labelSingle="$t('Mostrar Botón, Orden Servicio')"
                :variant="'switch'"
              />

              <LmCheckbox
                class="col-12 col-md-12"
                v-model="form.showWelcomeSignButton"
                :labelSingle="$t('Mostrar Botón, Cartel de Bienvenida')"
                :variant="'switch'"
              />

            </b-row>
          </b-card>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('Additional Info')">
          <div class="flex px-3">
            <LmLanguageSelector
              class="w-72"
              :value="language"
              @change="(value) => { language = value }"
            />
              <div class="w-20 ml-4">
                <a-button
                type="primary"
                value="Agregar"
                @click="addPassengerDescription"
                style="margin-top: 36px;"
                >
                Agregar descripción
                </a-button>
              </div>
          </div>

          <a-tabs class="col-12 my-4">
                <a-tab-pane :key="item.code" :tab="item.shortName" v-for="(item, index) in form.passengers_description">
                  <LmEditor
                    class=""
                    v-model="form.passengers_description[index].description"
                    :label="$t('Description for Passengers')"
                  />
                  <a-button
                    type="danger"
                    class="mt-2"
                    @click="removePassengerDescription(index)"
                  >
                    Eliminar descripción
                  </a-button>
                </a-tab-pane>
          </a-tabs>

        </a-tab-pane>
        <a-tab-pane v-if="isOnEditMode" key="3" :tab="$t('Daily view')">
          <b-card>
            <LmDailyPrograms
              serviceEndpoint="programs"
              calendarProgramRoute="/programs/todos"
              newProgramRoute="/programs/new"
              passengerEditRoute="/passengers/edit/"
              editProgramRoute="/programs/edit/"
              servicesEditRoute="/services/edit/"
              hotelsEditRoute="/hotels/edit/"
              leadersEditRoute="/leaders/edit/"
              vehiclesEditRoute="/vehicles/edit/"
              :serviceIdToFilter="$route.params.id"
              :showNationalParksButton="form.showNationalParksButton"
              :showOrderServiceButton="form.showOrderServiceButton"
              :showWelcomeSignButton="form.showWelcomeSignButton"
              :backgroundSigns="form.backgroundSigns"
            />
          </b-card>
        </a-tab-pane>
      </a-tabs>

      <div :class="isOnModal ? 'flex items-center gap-1' : 'buttons'">
        <LmButton
          v-if="isOnModal"
          buttonClass="btn-secondary"
          :value="$t('close')"
          @click="onClose"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-else
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click="onGoBack"
          :isProcessing="isProcessing"
        />

        <LmButton
          buttonClass="btn-primary"
          :value="$t('save')"
          @click="onSubmit"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && !form.deleted"
          buttonClass="btn-danger"
          :value="$t('delete')"
          @click="onDeleteConfirmation"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && form.deleted"
          value="Reactivar"
          buttonClass="btn-success"
          @click="onReactivateConfirmation"
          :isProcessing="isProcessing"
        />

      </div>
    </template>
    <b-row v-else>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col md="12" class="my-4">
        <div>
          <div class="d-flex flex-wrap mb-3" style="gap: 1rem">
            <span
              class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
              style="gap: 1rem"
              v-for="(item, index) in 4"
              :key="index"
            >
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton width="100px"></b-skeleton>
            </span>
          </div>
          <b-skeleton type="button" width="150px"></b-skeleton>
        </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmDatePicker from '@/components/form/elements/LmDatePicker'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmTextInput from '../../components/form/elements/LmTextInput'
import LmEditor from '@/components/form/elements/lmEditor'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmDailyPrograms from '@/views/lumbretravel/LmDailyPrograms'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmLanguageSelector from '../../components/form/elements/LmLanguageSelector.vue'

// Mixins
import lmStandardFormHelperMixin from '@/mixins/lmStandardFormHelperMixin'

// Utils
import { required } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
// import { add } from 'lodash'

export default {
  mixins: [lmStandardFormHelperMixin],
  components: {
    LmDatePicker,
    LmTextInput,
    LmTextArea,
    LmEditor,
    LmTreeSelect,
    LmDailyPrograms,
    LmButton,
    LmCheckbox,
    LmUploadFiles,
    LmLanguageSelector
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    isOnModal: {
      type: Boolean,
      default: false
    },
    frontendRouteToRedirectAfterCreated: {
      type: String
    },
    passengerActivitiesEndpoint: {
      type: String
    },
    providersEndpoint: {
      type: String,
      required: true
    },
    serviceEndpoint: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      form: {
        name: '',
        description: '',
        provider: null,
        reference: '',
        deleted: false,
        passengers_description: [],
        showNationalParksButton: false,
        showOrderServiceButton: true,
        showWelcomeSignButton: false,
        backgroundSigns: []
      },
      language: { code: 'es', shortName: 'ES', longName: 'Español (Español)', icon: '🇪🇸' },
      providerOptions: [],
      isProcessing: true
    }
  },
  computed: {
    acceptedImages () {
      return [
        { id: 1, name: 'PNG' },
        { id: 2, name: 'JPG' },
        { id: 3, name: 'JPEG' },
        { id: 4, name: 'WEBP' }
      ]
    }
  },
  validations: {
    form: {
      name: { required }
    }
  },
  methods: {
    updateBackgroundSigns (newValue) {
      console.log('pasa por aquí...')
      // console.log('newValue:', this.form.backgroundSign)

      // this.$emit('backgroundSigns', this.form.backgroundSigns)
    },
    removePassengerDescription (index) {
      this.form.passengers_description.splice(index, 1)
    },
    addPassengerDescription () {
      // Verificar si this.language ya está en passengers_description
      console.log('this.form.passengers_description:', this.form.passengers_description)
      console.log('this.language:', this.language)
      const exists = this.form.passengers_description.some(el => el.shortName === this.language.shortName)
      console.log('exists:', exists)
      if (!exists) {
        this.form.passengers_description.push(this.language)
      } else {
        console.log(`La descripción para el idioma ${this.language.shortName} ya existe.`)
      }
    }
  },
  async created () {
    try {
      console.log('providersEndpoint:', this.providersEndpoint)
      const providersResponse = await commonsApi.axiosGetWrapper(this.providersEndpoint)
      this.providerOptions = providersResponse.data.items.map(el => ({ id: el._id, name: el.name }))
    } catch (error) {
      console.error('Error fetching providers:', error)
    }
  }
}
</script>
